export const DOCUMENT_GROUPS = [
  {
    id: "personal",
    title: "เอกสารส่วนบุคคล",
    titleEn: "Personal Documents",
    items: [
      "บัตรประจำตัวประชาชน (Thai ID Card)",
      "หนังสือเดินทาง (Passport)",
      "ทะเบียนบ้าน (House Registration)",
      "สูติบัตร (Birth Certificate)",
      "มรณบัตร (Death Certificate)",
      "ทะเบียนสมรส (Marriage Certificate)",
      "ใบหย่า (Divorce Certificate)",
      "ใบเปลี่ยนชื่อ–สกุล (Name/Surname Change)",
      "หนังสือรับรองโสด (Single Status Affidavit)",
      "ใบรับรองการเกิด/ตาย จากโรงพยาบาล",
      "ใบขับขี่ (Driving License)",
      "ทะเบียนรับบุตรบุญธรรม (Adoption Certificate)",
    ],
  },
  {
    id: "education",
    title: "เอกสารการศึกษา",
    titleEn: "Educational Documents",
    items: [
      "ใบรับรองผลการศึกษา (Transcript / ปพ.1)",
      "ปริญญาบัตร (Diploma / Degree)",
      "ใบรับรองสถานภาพนักศึกษา",
      "ใบรับรองการสำเร็จการศึกษา",
      "Recommendation Letter",
      "Statement of Purpose / Study Plan",
      "ผลสอบ IELTS / TOEFL / TOEIC",
      "ผลสอบ SAT / GRE / GMAT",
      "Certificate of Course / Training",
      "ใบรับรองวิทยฐานะ ก.ค.ศ.",
      "ผลการเรียนระดับมัธยม (ปพ.1, ปพ.2, ปพ.7)",
      "Curriculum Vitae / Resume",
    ],
  },
  {
    id: "business",
    title: "เอกสารธุรกิจ & นิติบุคคล",
    titleEn: "Business & Corporate",
    items: [
      "หนังสือมอบอำนาจ (Power of Attorney)",
      "หนังสือรับรองบริษัท (Company Affidavit)",
      "Memorandum & Articles of Association",
      "Board Resolution / มติที่ประชุม",
      "บัญชีรายชื่อผู้ถือหุ้น (บอจ.5)",
      "สัญญาธุรกิจ / MOU / NDA",
      "Distribution / License / Franchise Agreement",
      "Good Standing Certificate",
      "งบการเงิน / Audit Report",
      "ใบทะเบียนพาณิชย์ / ภพ.20",
      "Trademark / Patent / Copyright",
      "Affidavit / Declaration / Statement",
    ],
  },
  {
    id: "legal",
    title: "เอกสารกฎหมาย & ศาล",
    titleEn: "Legal & Court Documents",
    items: [
      "คำพิพากษา / คำสั่งศาล",
      "พินัยกรรม (Last Will and Testament)",
      "หนังสือยินยอม (Consent Letter)",
      "หนังสือรับสภาพหนี้",
      "บันทึกข้อตกลง / สัญญาประนีประนอม",
      "ใบสำคัญการจดทะเบียนสมรส (Foreign)",
      "Court Order / Subpoena",
      "Statutory Declaration",
      "Affidavit of Support / Sponsorship",
      "Letter of No Impediment",
      "หนังสือรับรองการปกครองบุตร",
      "Apostille / Legalization Stamp",
    ],
  },
  {
    id: "medical",
    title: "เอกสารทางการแพทย์",
    titleEn: "Medical Documents",
    items: [
      "ใบรับรองแพทย์ (Medical Certificate)",
      "ใบรับรองแพทย์ 5 โรค (วีซ่า)",
      "ใบรับรองแพทย์สภา (Medical Council Cert)",
      "ใบประกอบวิชาชีพแพทย์ / พยาบาล / เภสัช",
      "ใบรับรองการฉีดวัคซีน (Yellow Book)",
      "ผลตรวจสุขภาพ / Lab Report",
      "ใบรับรองการตั้งครรภ์ / คลอดบุตร",
      "ประวัติการรักษา (Medical History)",
      "Vaccination Certificate (WHO)",
      "Fit-to-Fly / Fit-to-Work Certificate",
      "ใบส่งตัวผู้ป่วย (Referral Letter)",
      "ใบรับรองการเสียชีวิตทางการแพทย์",
    ],
  },
  {
    id: "police-bg",
    title: "ตรวจประวัติ & คดีอาญา",
    titleEn: "Police & Background",
    items: [
      "ใบรับรองความประพฤติ (Good Conduct)",
      "Police Clearance Certificate (PCC)",
      "ใบตรวจประวัติอาชญากร (CID)",
      "Criminal Record Check (ภาษาอังกฤษ)",
      "ใบรับรองไม่มีคดีค้าง",
      "ใบรับรองพิมพ์ลายนิ้วมือ",
      "FBI Background Check (USA)",
      "DBS Check (UK)",
      "AFP Check (Australia)",
      "RCMP Check (Canada)",
      "Singapore CRC",
      "ประวัติคดีต่างประเทศ (ทุกประเทศ)",
    ],
  },
  {
    id: "property",
    title: "เอกสารอสังหาฯ & การเงิน",
    titleEn: "Property & Financial",
    items: [
      "โฉนดที่ดิน (Land Title Deed)",
      "นส.3 / นส.3ก",
      "สัญญาซื้อขายที่ดิน / อาคาร",
      "สัญญาเช่า (Lease Agreement)",
      "หนังสือรับรองการถือกรรมสิทธิ์ห้องชุด (อช.2)",
      "Bank Statement (3–6 เดือน)",
      "หนังสือรับรองเงินฝาก (Bank Letter)",
      "หนังสือรับรองเครดิต",
      "Tax Invoice / Receipt",
      "ภงด.90 / ภงด.91",
      "หนังสือรับรองภาษี (Tax Residence Certificate)",
      "ประกันชีวิต / ประกันสุขภาพ",
    ],
  },
  {
    id: "work-visa",
    title: "เอกสารทำงาน & วีซ่า",
    titleEn: "Employment & Visa",
    items: [
      "หนังสือรับรองการทำงาน (Employment Letter)",
      "Slip เงินเดือน (Payslip)",
      "ใบรับรองประสบการณ์ทำงาน (สปส./กระทรวงแรงงาน)",
      "สัญญาจ้างงาน (Employment Contract)",
      "Work Permit / WP.3",
      "ใบอนุญาตประกอบวิชาชีพ",
      "Job Offer Letter (ต่างประเทศ)",
      "Sponsor Letter / Invitation Letter",
      "แบบฟอร์มวีซ่าทุกประเทศ",
      "DS-160, DS-260 (USA)",
      "VAF / Online Application (UK, Schengen)",
      "Cover Letter สำหรับวีซ่า",
    ],
  },
] as const;

export const TOTAL_DOC_TYPES = DOCUMENT_GROUPS.reduce((s, g) => s + g.items.length, 0);
